{
  "close": "Sule",
  "notifications": "{count, plural, one {# teatis} other {# teatist}}."
}
